import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateCategoryCommand,
  GetAllCategoriesCommand,
  UpdateCategoryCommand,
} from './category.commands';
import {
  CreatedCategoryEvent,
  GotAllCategoriesEvent,
  UpdatedCategoryEvent,
} from './category.events';

@Injectable()
export class CategoryEffects {
  prefix = 'category';
  createCategoryCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllCategoriesCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateCategoryCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createCategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateCategoryCommand,
      CreatedCategoryEvent,
      this.prefix,
    );
    this.getAllCategoriesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllCategoriesCommand,
      GotAllCategoriesEvent,
      this.prefix,
    );
    this.updateCategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateCategoryCommand,
      UpdatedCategoryEvent,
      this.prefix,
    );
  }
}
